<template>
  <WsMain>
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsTitle>{{_title}} 版本列表</WsTitle>
    <div class="ws-button-group">
      <WsBtn
        v-if="editable"
        color="textSecondary"
        outlined
        :to="`/${modelName}/${id}/version/${_versionId}/update/?redirect=${this.$route.fullPath}`"
      >
        <v-icon left>mdi-pencil</v-icon> 編輯歷史版本
      </WsBtn>
      <WsBtn
        v-if="deletable"
        @click="$_onDelete(tab)"
        color="deleteBtn white--text"
      >
        <v-icon left>mdi-delete</v-icon> 刪除
      </WsBtn>
      <span
        v-for="(item,index) in customBtns"
        :key="index"
        class="mx-2"
      >
        <WsBtn
          v-show="$_checkDisplayOnModelData(item.checkDisplayOnModelData)"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          @click="$_onCustom(item)"
        >
          <v-icon left>{{item.icon}}</v-icon> {{item.title}}
        </WsBtn>
      </span>
    </div>
    <!-- <WsLocalePicker
      v-if="localeMode"
      title="切換查看多國語言內容"
      v-model="selectingLocale"
    ></WsLocalePicker> -->
    <v-tabs
      class="mt-5"
      background-color="transparent"
      vertical
      v-model="tab"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(tab,tabIndex) in versionsData"
        :key="`tab-${tabIndex}`"
      > {{$moment(tab[versionTimestampKey]).format('YYYY.MM.DD')}}
      </v-tab>
      <v-tabs-items
        v-model="tab"
        class="transparent ml-5"
      >
        <v-tab-item
          v-for="(tab,tabIndex) in versionsData"
          :key="`item-${tabIndex}`"
        >
          <WsCard>
            <WsContent>
              <WsInfo
                v-for="(showField,showFieldIndex) in showFields"
                :key="`${showFieldIndex}`"
                :label="fields[showField].label"
                :type="fields[showField].type"
                :fields="fields[showField].fields"
                :displayLabel="fields[showField].displayLabel"
                :value="tab[showField]"
                :locale="_selectingLocale"
                :originData="tab"
                :hideOnNull="hideOnNull"
              >
              </WsInfo>
            </WsContent>
          </WsCard>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <WsDataExpandList
      v-if="hasExpandList && _versionId"
      ref="wsDataExpandList"
      :modelName="subList.modelName"
      :label="subList.label"
      :locale="_selectingLocale"
      :fields="subList.fields"
      :titleKey="subList.titleKey"
      :searchMode="subList.searchMode"
      :batchMode="subList.batchMode"
      :fieldsRead="subList.fieldsRead"
      :modeVersions="subList.modeVersions"
      :orderBy="subList.orderBy"
      :orderWay="subList.orderWay"
      :hideOnNull="subList.hideOnNull"
      :itemVersionLinkCreatable="subList.itemVersionLinkCreatable"
      :itemVersionReadable="subList.itemVersionReadable"
      :itemDeletable="subList.itemDeletable"
      :itemEditable="subList.itemEditable"
      :itemLinkCheckable="subList.itemLinkCheckable"
      :itemVersionReadableUrl="subList.itemVersionReadableUrl"
      :itemVersionCreatable="subList.itemVersionCreatable"
      :isGetAll="subList.isGetAll"
      :modelVersionName="subList.modelVersionName"
      :expandDisable="subList.expandDisable"
      :hasSequence="hasSequence"
      :hasChapters="hasChapters"
      :hasCatchVersion="hasCatchVersion"
      :modelData="modelData"
      :parentModelName="$_getParentModelName(subList)"
      :parentState="$_getParentState(subList)"
      :showFields="showFields"
      :tabSetting="subList.tabSetting"
      :params="_customSubParams"
      :customParentData="_customParentData"
      :isVersionAPI="subList.isVersionAPI"
      :fetchWithParams="subList.fetchWithParams"
      :batchLink="subList.batchLink"
      :sequenceFields="sequenceFields"
      :customBtns="customBtns"
      :staticModelData="staticModelData"
      :customCreateAction="customCreateAction"
      :customUpdateAction="customUpdateAction"
      :itemCreatable="subList.itemCreatable"
      @created="$_onCreated($event)"
      @deleted="$_onDeleted($event)"
      @custom-event="$_onCustomEvent($event)"
    ></WsDataExpandList>
    <WsDataReadOnlyList
      v-else-if="hasExpandSystemClass"
      ref="wsDataExpandList"
      :modelName="subList.modelName"
      :label="subList.label"
      :parentModelName="$_getParentModelName(subList)"
      :parentState="$_getParentState(subList)"
      :locale="_selectingLocale"
      :fields="subList.fields"
      :titleKey="subList.titleKey"
      :searchMode="subList.searchMode"
      :batchMode="subList.batchMode"
      :fieldsRead="subList.fieldsRead"
      :modeVersions="modeVersions"
      :rootModelName="modelName"
      :modelData="modelData"
      :orderBy="subList.orderBy"
      :orderWay="subList.orderWay"
      :hideOnNull="subList.hideOnNull"
      :filterSelects="filterSelects"
      :showExpand="showExpand"
      :showFields="showFields"
      :createVersion="createVersion"
      :itemVersionCreatable="itemVersionCreatable"
      :itemVersionLinkCreatable="itemVersionLinkCreatable"
      :itemVersionReadable="itemVersionReadable"
      :itemDeletable="itemDeletable"
      :itemEditable="itemEditable"
      :itemLinkCheckable="itemLinkCheckable"
      :params="_customSubParams"
      :postData="$_getPostData(subList)"
      :isGetAll="subList.isGetAll"
      :modelVersionName="subList.modelVersionName"
      :hasSequence="subList.hasSequence"
      :hasChapters="subList.hasChapters"
      :hasCatchVersion="true"
      :customParentData="_customParentData"
      :expandDisable="subList.expandDisable"
      :filterName="filterName"
      :filterSubName="filterSubName"
      :isVersionAPI="subList.isVersionAPI"
      :itemVersionReadableUrl="subList.itemVersionReadableUrl"
      :fetchWithParams="subList.fetchWithParams"
      @created="$_onCreated($event)"
      @deleted="$_onDeleted($event)"
    ></WsDataReadOnlyList>
    <!-- Delete Dialog -->
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteSubmit()"
    />
  </WsMain>
</template>

<script>
export default {
  data: () => ({
    tab: 0,
    modelData: null,
    versionsData: [],
  }),
  props: {
    showPreRouteInBreadCrumbs: {
      type: Boolean,
      default: true,
    },
    titleKey: {
      type: String,
      default: "text",
    },
    versionTimestampKey: {
      type: String,
      default: "created_at",
    },
    label: String,
    localeMode: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    modelName: String,
    versionModelName: String,
    fields: Object,
    backRouteText: {
      type: String,
      default: "返回",
    },
    showFields: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    customBreads: {
      type: Array,
    },
    hideOnNull: {
      type: Boolean,
      default: false,
    },
    hasExpandList: {
      type: Boolean,
      defalut: false,
    },
    subList: {
      type: Object,
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    sequenceFields: {
      type: [Object, Array],
    },
    hasExpandSystemClass: {
      type: Boolean,
      defalut: false,
    },
    modeVersions: {
      type: Boolean,
      default: false,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    itemVersionCreatable: {
      type: Boolean,
      default: false,
    },
    itemVersionReadable: {
      type: Boolean,
      default: true,
    },
    itemDeletable: {
      type: Boolean,
      default: true,
    },
    itemEditable: {
      type: Boolean,
      default: true,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
      default: false,
    },
    itemLinkCheckable: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Function,
    },
    filterName: {
      type: String,
    },
    filterSubName: {
      type: String,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    staticModelData: {
      type: Function,
    },
    customCreateAction: {
      type: Function,
    },
    customUpdateAction: {
      type: Function,
    }
  },
  methods: {
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
    },
    async $_onDeleteSubmit() {
      this.$refs.deleteDialog.startLoading();
      try {
        await this.$axios.delete(
          `/${this.versionModelName}/${this.versionsData[this.tab].id}`
        );
        this.$_fetchData();
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.deleteDialog.close();
      }
    },
    async $_fetchData() {
      this.$store.dispatch("app/startPageLoading");
      this.$store.dispatch("locale/changeLanguageAble");
      const apiTasks = [];
      // Modeldata
      let modelDataGetUrl = `/${this.modelName}/${this.id}`;
      apiTasks.push(this.$axios.get(modelDataGetUrl));
      // Versions
      let params = {
        order_by: this.versionTimestampKey,
        order_way: "desc",
      };
      let versionsGetUrl = "";
      if (this.hasCatchVersion) {
        versionsGetUrl = `/${this.versionModelName}`;
        params[this.modelName] = this.id;
      } else {
        versionsGetUrl = `/${this.modelName}/${this.id}/${this.versionModelName}`;
      }
      if (this.localeMode) {
        versionsGetUrl += `?locale=${this._selectingLocale}`;
      }
      apiTasks.push(
        this.$axios.get(versionsGetUrl, {
          params: params,
        })
      );
      try {
        const resArr = await Promise.all(apiTasks);
        this.modelData = resArr[0].data.data;
        this.versionsData = resArr[1].data.data;
        this.$emit("input", resArr[0].data.data);
        this.$emit("getVersionData", {versionData: resArr[1].data.data, tab: this.tab})
      } catch (error) {
        alert("取得資料錯誤");
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    $_checkDisplayOnModelData(displayModelData) {
      if (!displayModelData) {
        return true;
      } else {
        return displayModelData(this.modelData);
      }
    },
    async $_onCustom(item) {
      if (item.emit) {
        this.$emit(item.emit, { versionId: this._versionId });
      }
    },
    $_getParentState(subList) {
      if (subList.modeParentVersions && this.versionsData.length) {
        return this.versionsData[this.tab].id;
      } else if (this.modelData) {
        return this.modelData.id;
      } else {
        return null
      }
    },
    $_getParentModelName(subList) {
      if (subList.modeParentVersions) {
        return this.versionModelName;
      } else {
        return this.modelName;
      }
    },
    $_getPostData(item) {
      let _params = {};
      if (item.modeParent) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelName}s`] = this.modelData.id;
        } else {
          _params[`${this.modelName}`] = this.$_getParentState(item);
        }
      }
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    $_onCustomEvent($event) {
      this.$emit($event.customEmitEvent, {...$event, parentId: this.versionsData[this.tab].id});
    },
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _title() {
      if (!this.modelData) {
        return this.label;
      } else {
        return this.$_CMS_getValueByFieldKey(this.titleKey, this.modelData);
      }
    },
    _breadcrumbsItems() {
      if (this.customBreads) {
        return this.customBreads;
      } else {
        const _breadcrumbsItems = [];
        if (this.showPreRouteInBreadCrumbs) {
          _breadcrumbsItems.push({
            text: this.label,
            to: `/${this.modelName}`,
            disabled: false,
          });
          _breadcrumbsItems.push({
            text: this._title,
            to: `/${this.modelName}/${this.id}`,
            disabled: false,
          });
        }
        if (this.versionsData.length) {
          if (this.versionsData[this.tab].name) {
            _breadcrumbsItems.push({
              text: `${this.versionsData[this.tab].name} 版本列表`,
              disabled: true,
            });
          } else {
            _breadcrumbsItems.push({
              text: `版本列表`,
              disabled: true,
            });
          }
        } else {
          _breadcrumbsItems.push({
            text: `版本列表`,
            disabled: true,
          });
        }
        return _breadcrumbsItems;
      }
    },
    _backRoute() {
      if (this.backRoute) {
        return this.backRoute;
      } else {
        return `/${this.modelName}`;
      }
    },
    _versionId() {
      if (this.versionsData.length) {
        return this.versionsData[this.tab].id;
      } else {
        return null;
      }
    },
    _customSubParams() {
      const newObj = {
        [`${this.versionModelName}s`]: this._versionId,
        modelName: this.modelName,
      };
      return newObj;
    },
    _customParentData() {
      if (this.customParentData) {
        return this.customParentData(this.modelData);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.$_fetchData();
  },
  watch: {
    tab(){
      this.$emit("getVersionData", {versionData: this.versionsData, tab: this.tab})
    }
  }
};
</script>

<style>
</style>